import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import './GroupByButton.css';

export const GroupByButton = ({ count, onClick }) => {
  return (
    
    <div className="group-btn" onClick={onClick}>
      <FontAwesomeIcon icon={faLayerGroup} className="group-icon" />
      <span className="group-label">Group</span>
    </div>
  );
};
